export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12m4.5.17 1.41-1.41 2.59 2.58 5.59-5.59 1.41 1.42-7 7z\"/>"
};